import { Link } from 'react-router-dom';

const CATEGORIES = [
  { slug: 'ultraleggeri', name: 'Ultraleggeri' },
  { slug: 'propulsione-singola', name: 'Propulsione Singola' },
  { slug: 'propulsione-multipla', name: 'Propulsione Multipla' },
  { slug: 'turboelica', name: 'Turboelica' },
  { slug: 'jet', name: 'Jet' },
  { slug: 'elicotteri', name: 'Elicotteri' },
];

export default function Footer() {
  return (
    <footer className="bg-zinc-950 border-t border-zinc-800/50 pt-16 pb-8" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="hidden md:block">
            <Link to="/" className="block">
              <img src="/footer-logo.png" alt="AeroDeals" className="h-48 w-auto object-contain" />
            </Link>
          </div>

          <div>
            <h4 className="text-xs font-mono uppercase tracking-[0.2em] text-[#C5A059] mb-4">Categorie</h4>
            <ul className="space-y-2">
              {CATEGORIES.map(cat => (
                <li key={cat.slug}>
                  <Link to={`/listings?category=${cat.slug}`} className="text-sm text-zinc-400 hover:text-white transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-mono uppercase tracking-[0.2em] text-[#C5A059] mb-4">Servizi</h4>
            <ul className="space-y-2">
              <li><Link to="/services/price-estimator" className="text-sm text-zinc-400 hover:text-white transition-colors">Aircraft Price Estimator</Link></li>
              <li><Link to="/services/cost-calculator" className="text-sm text-zinc-400 hover:text-white transition-colors">Operating Cost Calculator</Link></li>
              <li><Link to="/consulenze-compravendita-velivoli" className="text-sm text-zinc-400 hover:text-white transition-colors">Consulenze</Link></li>
              <li><Link to="/lettera-di-intenti-compravendita-velivolo-tra-privati" className="text-sm text-zinc-400 hover:text-white transition-colors">Lettera di Intenti</Link></li>
              <li><Link to="/piano-di-acquisizione-velivolo" className="text-sm text-zinc-400 hover:text-white transition-colors">Piani di Acquisizione</Link></li>
              <li><Link to="/spazio-pubblicitario" className="text-sm text-zinc-400 hover:text-white transition-colors">Spazio Pubblicitario</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-mono uppercase tracking-[0.2em] text-[#C5A059] mb-4">Blog</h4>
            <ul className="space-y-2">
              <li><Link to="/blog?categoria=news-trend" className="text-sm text-zinc-400 hover:text-white transition-colors">News & Trend</Link></li>
              <li><Link to="/blog?categoria=guide-acquisto" className="text-sm text-zinc-400 hover:text-white transition-colors">Guide all'Acquisto</Link></li>
              <li><Link to="/blog?categoria=guide-vendita" className="text-sm text-zinc-400 hover:text-white transition-colors">Guide alla Vendita</Link></li>
              <li><Link to="/blog?categoria=mercato-aeronautico" className="text-sm text-zinc-400 hover:text-white transition-colors">Mercato Aeronautico</Link></li>
              <li><Link to="/blog?categoria=costi-gestione" className="text-sm text-zinc-400 hover:text-white transition-colors">Costi e Gestione</Link></li>
              <li><Link to="/blog?categoria=confronti-scelte" className="text-sm text-zinc-400 hover:text-white transition-colors">Confronti e Scelte</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800/50 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-zinc-600">&copy;2026 AeroDeals by MGB Aviation. Tutti i diritti riservati. VAT IT13672210963</p>
          <div className="flex gap-6 text-xs text-zinc-600">
            <Link to="/privacy" className="hover:text-zinc-400 transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-zinc-400 transition-colors">Termini</Link>
            <span className="hover:text-zinc-400 cursor-pointer transition-colors">Cookie</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
